import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import brandConfig from './brandConfig';

const domain = window.location.hostname.replace(/^www\./, '');
const { logo, flag } = brandConfig[domain] || brandConfig.default;

const Header = () => {
  const { t } = useTranslation();
  return (
    <AppBar position="static">
      <Toolbar
        sx={{
          pb: 2,
          pt: 2,
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between'
        }}
      >
        {/* Logo a la izquierda */}
        <a
          href="/"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-end', ml: 2 }}>
            <img src={logo} alt={t('header.logoAlt', 'Mevuelo Logo')} style={{ height: 50 }} />
          </Box>
        </a>
        {/* Bandera a la derecha */}
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mr: 2 }}>
          <img src={flag} alt={t('header.flagAlt', 'Country Flag')} style={{ height: 30 }} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
